<template>
  <v-dialog v-model="isFeastedDialog" :persistent="false" max-width="400">
    <v-card elevation="2">
      <div role="contentinfo">
        <v-img
          :src="
            feastedShopSettings.img || require('@/assets/images/no-photo.svg')
          "
        ></v-img>
      </div>
      <div class="icon-window-close">
        <v-icon @click.capture="closeDialog()">
          {{ icons.mdiWindowClose }}
        </v-icon>
      </div>
      <v-card-text
        class="text-center dialog-card-text dark--text mt-4"
        v-html="feastedShopSettings.msg"
        v-if="feastedShopSettings && feastedShopSettings.msg"
      >
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { makeHydrationDialog } from '@/mixins/dialogMixin'
export default {
  name: 'isFeastedDialog',
  data: () => ({
    isFeastedDialog: false,
  }),
  mixins: [makeHydrationDialog()],
  methods: {
    closeDialog() {
      if (this.isFeastedDialog) this.$set(this, this.$options.name, false)
    },
  },
  mounted() {
    if (this.feastedShopSettings?.enabled)
      this.$set(this, this.$options.name, true)
  },
}
</script>

<style></style>
